export const headerEuropeServerData = {
  title: "خرید سرور ابری اروپا",
  description: "سرور ابری اروپا؛ دسترسی به دیتاسنترهای جهانی",
  text: "سرورهای ابری اروپا در دیتاسنترهای پیشرفته‌ای واقع شده‌اند که کیفیت، سرعت دسترسی و آپ‌تایم بالا را ارائه می‌کند. خرید سرور ابری اروپا آبالون همچنین گزینه‌ای مناسب برای سازمان‌هایی است که به آی‌پی خارجی نیاز دارند یا می‌خواهند از مزایای زیرساخت‌های ابری پیشرفته بهره‌مند شوند. اگر به دنبال راهکاری حرفه‌ای، امن و مطمئن برای توسعه خدمات خود در سطح جهانی هستید، سرور ابری اروپا انتخابی برتر است.",
  leftButtonText: "خرید سرور ابری اروپا",
};

export const questions = [
  {
    title: "سرور ابری اروپا برای چه کسب‌وکارهایی مناسب است؟",
    answer:
      "سرورهای ابری اروپا برای کسب‌وکارهایی که کاربران خارج از کشور دارند یا به آی‌پی خارجی نیاز دارند، ایده‌آل هستند.",
  },
  {
    title: "آیا امکان تغییر منابع به‌صورت لحظه‌ای وجود دارد؟",
    answer:
      "بله، می‌توانید منابع را به‌صورت لحظه‌ای و با چند کلیک در پنل مدیریتی افزایش یا کاهش دهید.",
  },
  {
    title: "چه سیستم‌عامل‌هایی روی این سرورها قابل استفاده هستند؟",
    answer:
      "سرورهای ابری از سیستم‌عامل‌های ویندوز و لینوکس پشتیبانی می‌کنند و امکان انتخاب نسخه دلخواه وجود دارد.",
  },
  {
    title: "آیا این سرورها آی‌پی اختصاصی ارائه می‌دهند؟",
    answer:
      "بله، هر سرور با آی‌پی اختصاصی ارائه می‌شود تا امنیت و دسترسی کامل تضمین شود.",
  },
  {
    title:
      "چرا سرورهای ابری اروپا گزینه‌ای مناسب برای ذخیره‌سازی و بازیابی داده‌ها هستند؟",
    answer:
      "این سرورها با پایداری و امنیت بالا، فضای مناسبی برای ذخیره‌سازی و بازیابی داده‌های مهم در اختیار شما قرار می‌دهند.",
  },
  {
    title: "چگونه به این سرورها متصل شوم؟",
    answer:
      "به روش‌های متنوع می‌توان به سرورهای خارجی متصل شد. به عنوان مثال از طریق RDP به سرورهای ویندوز و SSH به سرورهای لینوکس. علاوه بر این امکان اتصال به سرورها از طریق پنل مدیریت سرور، حتی در صورت قطع دسترسی سرور به اینترنت وجود دارد.",
  },
  {
    title: "آیا این سرورها برای بار کاری متغیر مناسب هستند؟",
    answer:
      "بله، انعطاف‌پذیری بالای این سرورها آن‌ها را برای استارتاپ‌ها و سازمان‌هایی با نیازهای متغیر مناسب می‌کند.",
  },
  {
    title: "پایداری این سرورها چگونه است؟",
    answer:
      "با استفاده از زیرساخت‌های پیشرفته، این سرورها آپ‌تایم ۹۹.۹۹ درصد ارائه می‌دهند.",
  },
  {
    title: "آیا این سرورها از نظر امنیت مناسب هستند؟",
    answer:
      "بله، این سرورها با استفاده از زیرساخت‌های پیشرفته و پروتکل‌های امنیتی مدرن، حفاظت از داده‌ها و اطلاعات شما را تضمین می‌کنند.",
  },
];

export const featuresHourlyServer = [
  {
    title: "تحویل سرور در ۶۰ ثانیه",
    desc: "سرور ابری ساعتی با سیستم‌عامل انتخابی شما در کمتر از یک دقیقه آماده شده و به‌صورت کاملاً خودکار تحویل داده می‌شود.",
    logo: "1minute.svg",
    alt: "پیاده‌سازی IAM امنیت ابری آبالون",
  },
  {
    title: "انتخاب آسان سیستم‌عامل",
    desc: "هنگام خرید سرور ابری ساعتی، سیستم‌عامل دلخواه ویندوز یا لینوکس را انتخاب کرده و به سرعت تنظیمات دلخواه را اعمال کنید.",
    logo: "chooseOs.svg",
    alt: "پیاده‌سازی سندباکس امنیت ابری آبالون",
  },
  {
    title: "کنترل پیشرفته با کنسول تحت وب",
    desc: "با استفاده از کنسول تحت وب، حتی در صورت قطع دسترسی به اینترنت، به مدیریت و کنترل کامل سرور ابری ساعتی خود ادامه دهید.",
    logo: "console.svg",
    alt: "پیاده‌سازی SIEM امنیت ابری آبالون",
  },
  {
    title: "دسترسی جهانی به سرور",
    desc: "از هر نقطه جهان و در هر زمانی، به سرورهای ابری ساعتی متصل شوید و بدون محدودیت مکانی، سرویس‌های خود را مدیریت کنید.",
    logo: "global.svg",
    alt: "پیاده‌سازی DMZ امنیت ابری آبالون",
  },
  {
    title: "انعطاف در افزایش منابع",
    desc: "در هر لحظه از شبانه‌روز، منابع سرور ابری ساعتی خود را افزایش یا کاهش دهید تا پاسخی برای نیازهای لحظه‌ای کسب‌وکار خود داشته باشید.",
    logo: "increase.svg",
    alt: "ابزار مقابله با ویروس‌ها امنیت ابری آبالون",
  },
  {
    title: "پشتیبانی ۲۴/۷ رایگان",
    desc: "با سرور ابری ساعتی، از پشتیبانی حرفه‌ای و رایگان به‌صورت ۲۴/۷/۳۶۵ بهره‌مند شوید تا در هر شرایطی تنها یک تماس از حل مشکل‌تان فاصله داشته باشید.",
    logo: "24.svg",
    alt: "اسکن آسیب‌پذیری‌های امنیتی",
  },
  {
    title: "امنیت پیشرفته با فایروال",
    desc: "قوانین امنیتی سرور ابری ساعتی را مطابق نیازهای خود تنظیم کنید و با فایروال پیشرفته از سرورهای خود در برابر تهدیدات محافظت کنید.",
    logo: "firewall-new.svg",
    alt: "بازیابی ناشی از سانحه امنیت ابری آبالون",
  },
  {
    title: "آپ‌تایم ۹۹.۹۹ درصد",
    desc: "سرورهای ابری ساعتی با بالاترین سطح آپ‌تایم، تضمین می‌کنند که سرویس‌های شما همواره در دسترس باشند.",
    logo: "uptime.svg",
    alt: "پیاده‌سازی ابزارهای DLP امنیت ابری آبالون",
  },
];

export const benefitHourlyServer = [
  {
    name: "امنیت داده‌ها در اولویت",
    logo: "infrustructure.svg",
    alt: "انتخاب سطح سرویس حین خرید سرور ابری",
    title: "انتخاب سطح سرویس حین خرید سرور ابری",
  },
  {
    name: "پشتیبانی ۲۴/۷/۳۶۵",
    logo: "support.svg",
    alt: "پشتیبانی ۲۴ ساعته سرور ابری",
    title: "پشتیبانی ۲۴ ساعته سرور ابری",
  },
  {
    name: "سرویس منعطف برای نیازهای متنوع",
    logo: "sla.svg",
    alt: "زیرساخت ایمن سرور ابری",
    title: "زیرساخت ایمن سرور ابری",
  },
  {
    name: "پشتیبانی فنی رایگان",
    logo: "freeSupport.svg",
    alt: "پنل یکپارچه مدیریت سرور ابری",
    title: "پنل یکپارچه سرور ابری",
  },
  {
    name: "منابع پیشرفته برای بهترین عملکرد",
    logo: "hq.svg",
    alt: "کیفیت بالای منابع سرور ابری",
    title: "کیفیت بالای منابع سرور ابری",
  },
  {
    name: "یکپارچگی کامل در خدمات ابری",
    logo: "dashboard.svg",
    alt: "پشتیبانی رایگان سرور ابری آبالون",
    title: "پشتیبانی رایگان سرور ابری آبالون",
  },
];

export const tabItems = [
  {
    title: "پنل مدیریت سرور کاربردی",
    img: "ddos.svg",
    img_deactive: "ddos-d.svg",
    section_title: "پنل مدیریت سرور کاربردی",
    caption:
      "در پنل مدیریت سرور ابری اروپا، تمام سرورها به‌صورت تفکیک‌شده نمایش داده می‌شوند و اطلاعاتی مانند مدت‌زمان باقی‌مانده سرویس، آدرس آی‌پی و مشخصات سیستم‌عامل به‌راحتی قابل مشاهده است. همچنین، امکان دسترسی سریع به کنسول سرور برای عملیاتی نظیر روشن، خاموش، ری‌استارت و بازیابی فراهم شده است.",
    contentImg: "list-vps.f735948 1.svg",
    logo_alt: "مدیریت سرور ابری",
    logo_title: "مدیریت سرور ابری",
    img_alt: "پنل مدیریت سرور ابری",
    img_title: "پنل مدیریت سرور ابری",
  },
  {
    title: "تنظیمات فایروال",
    img: "waf-icon-active.svg",
    img_deactive: "waf-icon.svg",
    section_title: "تنظیمات فایروال",
    caption:
      "سرور ابری اروپا امکان تنظیم رول‌های متنوع فایروال را فراهم می‌کند. می‌توانید قوانین دلخواه ورودی و خروجی را بر اساس پروتکل، آدرس آی‌پی مبدا یا مقصد و پورت‌های مختلف تعریف کنید. همچنین، بدون هیچ محدودیتی در تعداد رول‌ها، امکان افزودن یا حذف قوانین در اختیار شما قرار دارد.",
    contentImg: "waf-vps.fcecd73 1.svg",
    alt: "تعیین محدودیت درخواست",
    logo_alt: "فایروال سرور ابری",
    logo_title: "فایروال سرور ابری",
    img_alt: "تنظیمات فایروال سرور ابری",
    img_title: "فایروال سرور ابری",
  },
  {
    title: "نمودار مصرف ترافیک سرور",
    img: "waf.svg",
    section_title: "نمودار مصرف ترافیک سرور",
    img_deactive: "waf-d.svg",
    caption:
      "سرور ابری اروپا به شما امکان مشاهده ترافیک مصرفی هر سرور را در قالب نمودارهای دقیق می‌دهد. با تنظیم بازه‌های زمانی دلخواه می‌توانید مصرف ترافیک روزانه را بررسی کنید.",
    contentImg: "traffic-vps.aa00c67 1.svg",
    alt: "فایروال وب (WAF)",
    logo_alt: "نمودار مصرف ترافیک سرور ابری",
    logo_title: "نمودار مصرف ترافیک سرور ابری",
    img_alt: "نمودار مصرف سرور ابری",
    img_title: "نمودار مصرف سرور ابری",
  },
];

export const hourlyServerUsage = [
  {
    title: "ترید سریع",
    desc: "سرور ابری ساعتی با ارائه آی‌پی عمومی و شبکه‌ای پرسرعت، گزینه‌ای ایده‌آل برای ترید است. این سرویس امکان خاموش کردن سرور در زمان عدم نیاز را فراهم می‌کند.",
    logo: "startup.svg",
    imgAlt: "DNS رایگان",
    imgTitle: "DNS رایگان",
  },
  {
    title: "محیط توسعه",
    desc: "محیط‌های تست و توسعه را به‌سادگی و با پرداخت هزینه ساعتی راه‌اندازی کنید و نرم‌افزارهای خود را آزمایش کنید.",
    logo: "test.svg",
    imgAlt: "سرورهای جهانی DNS ابری آبالون",
    imgTitle: "سرورهای جهانی DNS ابری آبالون",
  },
  {
    title: "بکاپ‌گیری",
    desc: "با سرور ابری ساعتی، نسخه‌های پشتیبان از داده‌های حساس خود تهیه کنید و با کمترین هزینه، از امنیت اطلاعات سازمان اطمینان داشته باشید..",
    logo: "disaster.svg",
    imgAlt: "DNS ابری با پشتیبانی از رکوردهای رایج",
    imgTitle: "DNS ابری با پشتیبانی از رکوردهای رایج",
  },
  {
    title: "پروژه‌های کوتاه‌مدت",
    desc: "برای پروژه‌های موقت و کوتاه‌مدت، سرور را با منابع مورد نیاز خود و مدت زمان دلخواه راه‌اندازی کرده و استفاده کنید..",
    logo: "virtualOrganization.svg",
    imgAlt: "آپ‌تایم صددرصد DNS ابری",
    imgTitle: "آپ‌تایم صددرصد DNS ابری",
  },
];

export const abalonPopularServices = [
  {
    title: "دیتاسنتر ابری",
    desc: "دیتاسنتر ابری تمامی قابلیت‌های یک دیتاسنتر فیزیکی را روی ابر برایتان فراهم می‌کند و می‌تواند پاسخی برای پیچیده‌ترین و تخصصی‌ترین نیازهای ابری شما باشد. ",
    logo: "VPC-Service.svg",
    route: "/vpc",
    imgAlt: "دیتاسنتر ابری آبالون",
    imgTitle: "دیتاسنتر ابری آبالون",
  },
  {
    title: "شبکه توزیع محتوا (CDN)",
    desc: "با استفاده از CDN، امنیت و سرعت بارگذاری وب‌سایت خود را بهبود دهید. داده‌های شما از طریق سرورهای توزیع‌شده همیشه نزدیک‌تر به کاربران خواهند بود.",
    logo: "CloudGuard-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوا (CDN) آبالون",
    imgTitle: "شبکه توزیع محتوا (CDN) آبالون",
  },
  {
    title: "DNS ابری",
    desc: "با استفاده از DNS ابری، بدون نیاز به مدیریت سرورهای DNS، رکوردها و Zoneهای DNS، همه دامنه‌های خود را مدیریت و در تمام جهان منتشر کرده و سرعت پاسخ‌گویی به کاربران را افزایش دهید.",
    logo: "DNS.svg",
    route: "/dns",
    imgAlt: "DNS ابری آبالون",
    imgTitle: "DNS ابری آبالون",
  },
  {
    title: "سرویس مدیریت شده",
    desc: "تحت سرویس‌های مدیریت شده، راهکارهای اختصاصی سازمان شما در حوزه ابری، از جمله نصب سیستم‌عامل و نرم‌افزار، طراحی معماری و مهاجرت ابری اجرا می‌شود.",
    logo: "ManagedService-Service.svg",
    route: "/manageservices",
    imgAlt: "سرویس مدیریت شده",
    imgTitle: "سرویس مدیریت شده",
  },
];

export const serviceFeatures = [
  {
    title: "سخت‌افزار قدرتمند و مطمئن",
    desc: "", //"تمامی فرایند افزودن دامنه و استفاده از خدمات DNS ابری آبالون کاملا رایگان است.",
    logo: "hq.svg",
    alt: "تامین امنیت ابری با محافظت در مقابل حملات DDoS",
    seo_title: "امنیت ابری با محافظت DDoS",
  },
  {
    title: "داشبورد ابری متمرکز و حرفه‌ای",
    desc: "", //"سرویس DNS ابری با سرورهایی در سراسر جهان، از تمامی دنیا و به صورت دائمی در دسترس است.",
    logo: "dashboard.svg",
    alt: "تامین امنیت ابری با فایروال",
    seo_title: "تامین امنیت ابری با فایروال",
  },
  {
    title: "خدمات پشتیبانی رایگان",
    desc: "", //"DNS ابری آبالون از رکوردهای رایج شامل TXT ،MX ،NS ،CNAME، AAAA ،A و … پشتیبانی می‌کند.",
    logo: "freeSupport.svg",
    alt: "تامین امنیت ابری با فایروال وب",
    seo_title: "تامین امنیت ابری با فایروال وب",
  },
  {
    title: "تضمین امنیت زیرساخت‌ها",
    desc: "", //"حداکثر آپ‌تایم، هرگونه نگرانی از دسترس خارج شدن سرویس DNS را رفع می‌کند.",
    logo: "infrustructure.svg",
    alt: "راهکارهای اختصاصی سازمانی برای تامین امنیت ابری",
    seo_title: "راهکارهای اختصاصی سازمانی امنیت ابری",
  },
];

export const europeVpsUsage = [
  {
    img: "disaster.svg",
    title: "بکاپ و بازیابی مطمئن با سرور ابری اروپا",
    title_en: "",
    desc: "سرورهای ابری اروپا آبالون گزینه‌ای مطمئن برای پشتیبان‌گیری دوره‌ای و مداوم از داده‌ها هستند. با زیرساخت‌های پیشرفته این سرورها، اطمینان داشته باشید که داده‌های حیاتی شما حتی در بحرانی‌ترین شرایط امن باقی می‌مانند و کسب‌وکار شما بدون اختلال به فعالیت خود ادامه می‌دهد. اگر به دنبال آرامش خاطر و پشتیبانی حرفه‌ای هستید، سرور ابری اروپا انتخابی ایده‌آل است.",
  },

  {
    img: "startup.svg",
    title: "انعطاف‌پذیری بالا برای استارتاپ‌های بلندپرواز",
    title_en: "",
    desc: "برای استارتاپ‌هایی که با بار کاری متغیر دست‌وپنجه نرم می‌کنند، سرور ابری اروپا همان نیروی کمکی است که همیشه آماده است. در لحظات اوج فعالیت، تنها با چند کلیک منابع خود را گسترش دهید و در زمان کاهش تقاضا، هزینه‌ها را با کاهش منابع مدیریت کنید. این انعطاف‌پذیری، نه‌تنها بهره‌وری را افزایش می‌دهد، بلکه به استارتاپ شما فرصت می‌دهد تا بدون دغدغه هزینه‌ها، به اهداف بزرگ‌تر فکر کند و مسیر رشد را با اطمینان طی کند.",
  },
  {
    img: "backup.svg",
    title: "دسکتاپ مجازی در دسترس",
    title_en: "",
    desc: "با سرور ابری اروپا آبالون، یک دسکتاپ مجازی قدرتمند با سیستم‌عامل دلخواه (ویندوز یا لینوکس) به شما ارائه می‌شود. این دسکتاپ با آی‌پی اختصاصی اروپا، همیشه و از هر نقطه جهان در دسترس است. چه برای مدیریت پروژه‌های حساس، چه برای دسترسی به منابع شخصی یا حرفه‌ای، سرور ابری اروپا ابزاری انعطاف‌پذیر و مطمئن است که بهره‌وری شما را به سطحی بالا می‌رساند.",
  },
  {
    img: "service.svg",
    title: "زیرساختی مطمئن برای سازمان‌ها",
    title_en: "",
    desc: "اگر به دنبال توسعه محصولات یا راه‌اندازی سرویس‌های جدید هستید، سرور ابری اروپا گزینه‌ای مناسب برای شما است. این سرور با مقیاس‌پذیری سریع، پایداری فوق‌العاده و آپ‌تایم تضمینی، زیرساختی ایده‌آل برای سازمان‌ها فراهم می‌کند. از راه‌اندازی وب‌سایت گرفته تا مدیریت خدمات پیشرفته، با سرور ابری اروپا می‌توانید با اطمینان و کیفیت بالا به اهداف خود برسید.",
  },
];

export const europeVpsFeatures = [
  {
    img: "chooseOs.svg",
    title: "انتخاب سیستم‌عامل دلخواه",
    desc: "با خرید سرور ابری اروپا، این امکان را دارید که سیستم‌عامل مورد نظر خود را از میان نسخه‌های مختلف ویندوز یا لینوکس متناسب با نیازهای خود انتخاب کنید.",
    imgAlt: "",
    imgTitle: "",
  },
  {
    img: "console.svg",
    title: "کنسول مدیریتی همیشه در دسترس",
    desc: "کنسول مدیریتی سرور ابری اروپا به شما امکان می‌دهد حتی در صورت قطع دسترسی اینترنت سرور، مدیریت آن را به‌سادگی انجام دهید.",
    imgAlt: "تعریف بی‌نهایت رکورد در DNS ابری",
    imgTitle: "تعریف بی‌نهایت رکورد در DNS ابری",
  },
  {
    img: "global.svg",
    title: "دسترسی از هر کجا، هر زمان",
    desc: "سرور ابری اروپا آبالون به شما امکان می‌دهد در هر لحظه و از هر نقطه دنیا، به سادگی به سرور خود دسترسی داشته باشید و خدمات خود را بدون توقف مدیریت کنید.",
    imgAlt:
      "پاسخ به درخواست‌های DNS ابری از نزدیک‌ترین پاپ‌سایت به کمک Anycast",
    imgTitle: "پاسخ به درخواست DNS ابری از نزدیک‌ترین پاپ‌سایت با Anycast",
  },
  {
    img: "24.svg",
    title: "پشتیبانی شبانه‌روزی بدون وقفه",
    desc: "با خرید سرور ابری اروپا، در هر ساعت از شبانه‌روز و در تمام روزهای سال، از خدمات پشتیبانی حرفه‌ای و قابل‌اعتماد بهره‌مند شوید.",
    imgAlt: "DNS رایگان بدون محدودیت در تعداد درخواست‌ها",
    imgTitle: "DNS رایگان بدون محدودیت به درخواست‌ها",
  },
];
